export default __webpack_public_path__ + "static/media/spaceship-preview.0996ffe7.png";